






























import loading from '@/components/loading.vue';
import editSystemSettingDialog from '@/components/settings/system-settings/edit-system-setting-dialog.vue';
import { SystemSetting } from '@/shared/system-setting';
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const settingsModule = namespace('settings');

@Component({
    components: {
        editSystemSettingDialog,
        loading,
    },
})
export default class SystemSettings extends Vue {
    @settingsModule.Getter('systemSettings') private systemSettings!: Array<SystemSetting>;

    private isLoading: boolean = true;
    private selectedSetting: SystemSetting | null = null;
    private editSettingDialogVisible: boolean = false;

    private get systemSettingFields(): Array<{}> {
        return [
            { key: 'name', label: 'Setting' },
            { key: 'value', label: 'Value' },
            { key: 'actions', label: '', class: 'col-1', tdClass: 'text-right' },
        ];
    }

    private onEditSetting(item: SystemSetting): void {
        this.selectedSetting = { ...item };
        this.editSettingDialogVisible = true;
    }

    private async onSaveAsync(item: SystemSetting): Promise<void> {
        try {
            await this.$store.dispatch(`settings/updateSystemSettingAsync`, { ...item });
            this.$snackbar.open({ message: `'${item.name}' has been successfully updated.`, type: 'is-success' });

            this.selectedSetting = null;
            this.editSettingDialogVisible = false;
        } catch (e) {
            if (e instanceof Error) {
                this.$snackbar.open({ message: e.message, type: 'is-danger' });
            } else {
                this.$snackbar.open({ message: `Could not update '${item.name}'. Please try again.`, type: 'is-danger' });
            }
        }
    }

    private onCancel(): void {
        this.selectedSetting = null;
        this.editSettingDialogVisible = false;
    }

    private async mounted(): Promise<void> {
        this.isLoading = true;

        await this.$store.dispatch(`settings/loadSystemSettingsAsync`);

        this.isLoading = false;
    }
}
